import { gql } from '@apollo/client';

export const FETCH_PRICE_LIST_BY_ID_QUERY = gql`
  query getPriceListData($planId: String, $fileCategory: FileCategory) {
    getPriceListData(planId: $planId, fileCategory: $fileCategory) {
      data
    }
  }
`;
export const FETCH_PARTNER_COVERAGE_BY_ID_QUERY = gql`
  query fetchPartnerCoverageById($coverageId: String) {
    fetchPartnerCoverageById(coverageId: $coverageId) {
      coverage
      docArn
      documentReferenceId
    }
  }
`;
export const FETCH_ALL_COVERAGES_QUERY = gql`
  query getCoverages(
    $sourceUrl: String
    $count: String
    $offset: Int
    $statusFilter: String
    $searchFilter: String
  ) {
    getCoverages(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      coverageList
      count
    }
  }
`;
